import { render } from "./RoomDetailsPage.vue?vue&type=template&id=4570a3ff&ts=true"
import script from "./RoomDetailsPage.vue?vue&type=script&lang=ts"
export * from "./RoomDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__